import React from 'react';
export var PlaybackRateButton = function (_a) {
    var children = _a.children, onClick = _a.onClick;
    return (React.createElement("button", { className: 'str-chat__message_attachment__playback-rate-button', "data-testid": 'playback-rate-button', onClick: onClick }, children));
};
